import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import moment from "moment";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import { getActivitylogAccountant } from "store/activitylogAccountant/actions";
import { isEmpty } from "lodash";
import "assets/scss/table.scss";

class AccountantHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };
  }

  componentDidMount() {
    const routeId = this.props.match?.params?.id;
    const id = routeId || this.state.user_id;

    console.log("Final ID to use:", id);

    if (id) {
      this.props.ongetActivitylogAccountant(id);
    } else {
      console.error("ID missing in request.");
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activitylogAccountant !== this.props.activitylogAccountant) {
      const logs = this.props.activitylogAccountant || [];
      console.log("[Component] Updated activity logs:", logs);
      if (!logs.length) {
        console.warn("[Component] No activity logs found for this user.");
      }
    }
  }

  render() {
    const { activitylogAccountant } = this.props;

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>History | Accountant</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
              title="History"
              breadcrumbItem="Activity Log Accountant"
            />
            <Row>
              <Col lg="8" className="offset-lg-2">
                <Card className="mb-2 d-flex justify-content-center">
                  <CardBody>
                    {!isEmpty(activitylogAccountant) &&
                      activitylogAccountant.map((log, key) => (
                        <div
                          key={"_card_" + key}
                          className="mb-3 p-3"
                          style={{
                            backgroundColor: "#f7f7f7",
                            // borderLeft: "5px solid purple",
                            borderRadius: "6px",
                          }}
                        >
                          {/* Small Date & Time */}
                          <div style={{ fontSize: "11px", color: "#777" }}>
                            {moment(log.reconciled_at).format(
                              "DD-MMM-YY, h:mm A"
                            )}
                          </div>

                          {/* Main Record Text */}
                          <div style={{ marginTop: "6px", fontSize: "14px" }}>
                            <b>{log.accountant_name}</b> reconciled Payment ID:
                            {""}
                            <b>{log.payment_id}</b> for lab{" "}
                            <b>{log.lab_name}</b> with bank{" "}
                            <b>{log.bank_name || "Unknown Bank"}</b>
                            <div
                              style={{
                                display: "flex",
                                marginTop: "6px",
                                fontSize: "14px",
                              }}
                            >
                              <div>
                                Account:{" "}
                                <b>{log.account_number || "Unknown"} </b>
                                Amount:{" "}
                                <b> {Number(log.amount).toLocaleString()}</b>
                              </div>
                            </div>
                            <div></div>
                            <div>
                              {log.comments && (
                                <>
                                  {" "}
                                  Comments: <b>{log.comments}</b>
                                </>
                              )}{" "}
                            </div>
                          </div>
                        </div>
                      ))}

                    {isEmpty(activitylogAccountant) && (
                      <Row>
                        <Col lg="12">
                          <div className="mb-5 text-center">
                            <h5 className="text-uppercase">
                              No activity logs exist.
                            </h5>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AccountantHistory.propTypes = {
  match: PropTypes.object,
  activitylogAccountant: PropTypes.array,
  ongetActivitylogAccountant: PropTypes.func,
};
const mapStateToProps = state => {
  console.log(
    "[mapStateToProps] Current state slice:",
    state.activitylogReducer
  );
  return {
    activitylogAccountant:
      state.activitylogReducer?.activitylogAccountant || [],
  };
};

const mapDispatchToProps = dispatch => ({
  ongetActivitylogAccountant: id => dispatch(getActivitylogAccountant(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AccountantHistory));
